// @ts-ignore
import App from './App.svelte';
function addStyleTag() {
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.type = 'text/css';
    stylesheet.href = process.env.BASE_URL + '/build/bundle.css';
    document.head.appendChild(stylesheet);
}
const id = 'twism-app-widget';
const className = 'twism-app-widget';
let target = document.getElementById(id);
if (!target) {
    target = document.createElement('div');
    target.id = id;
    target.classList.add(className);
    document.body.append(target);
    addStyleTag();
    console.warn('[twism]', 'widget loaded.');
    const app = new App({
        target,
        props: {}
    });
}
